<template>
    <div>
        <my-form v-model="form" readonly table>
            <my-form-item-group title="招标异常终止详情">
                <el-form-item label="异常编号" prop="yccode" class="table-full-row">
                    {{form.yccode||'-'}}
                </el-form-item>
                <el-form-item label="标段名称" prop="bdnamee" class="table-full-row">
                    {{form.bdname}}
                </el-form-item>
                <el-form-item label="招标终止类型" prop="extyctype" class="table-full-row">
                    {{form.extyctype||'-'}}
                </el-form-item>
                <el-form-item label="异常情况描述" prop="yccontent" v-if="form.extyctype==='废标公告'" class="table-full-row">
                    {{form.yccontent||'-'}}
                </el-form-item>
                <el-form-item label="内容" prop="yccontent" v-if="form.extyctype!=='废标公告'" class="table-full-row">
                    {{form.yccontent||'-'}}
                </el-form-item>
                <el-form-item label="交易方式" prop="by3" v-if="form.extyctype!=='废标公告'" class="table-full-row">
                    {{form.by3||'-'}}
                </el-form-item>
                <el-form-item label="成交结果" prop="by4" v-if="form.extyctype!=='废标公告'" class="table-full-row">
                    {{form.by4||'-'}}
                </el-form-item>
                <el-form-item label="提交时间" class="table-full-row">
                    {{form.tjtime||'-'}}
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            form:{}
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.yccode!==undefined){
            that.$get(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/ycdetail.json`,{id:this.$route.query.yccode}, (data, res) => {
                that.form=data.model;
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
